import PriceName from "./PriceName";
import PriceLink from "./PriceLink";

import PricingProfileName from "../../../../timber/components/pricingProfile/PricingProfileDetail/PricingProfileName";
import PricingProfileLink from "../../../../timber/components/pricingProfile/PricingProfileDetail/PricingProfileLink";

import TimberTypeName from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeName";
import TimberTypeLink from "../../../../timber/components/timberType/TimberTypeDetail/TimberTypeLink";

import TimberClassName from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassName";
import TimberClassLink from "../../../../timber/components/timberClass/TimberClassDetail/TimberClassLink";

import ThicknessClassName from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassName";
import ThicknessClassLink from "../../../../timber/components/thicknessClass/ThicknessClassDetail/ThicknessClassLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";

import Grid from '@mui/material/Grid';
import { Refresh, Clear, CheckBoxOutlined as CheckBoxOutlinedIcon, CheckBoxOutlineBlankOutlined as CheckBoxOutlineBlankOutlinedIcon } from "@mui/icons-material";
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";

import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const PriceDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" spacing={1} sx={{ justifyContent: "left" }}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Price-detail-title"
                    >
                        { label || t`Price` }: <PriceName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" spacing={1} sx={{ justifyContent: "right" }}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Price-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Price-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    
                    <Grid size={ {xs: 4} } data-testid="pricingProfileId-label" sx={{ textAlign: "left" }}><Trans>Pricing Profile</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="pricingProfileId-value" sx={{ textAlign: "left" }}>{ data.pricingProfileId ? (<PricingProfileLink id={ data.pricingProfileId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="timberTypeId-label" sx={{ textAlign: "left" }}><Trans>Timber Type</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="timberTypeId-value" sx={{ textAlign: "left" }}>{ data.timberTypeId ? (<TimberTypeLink id={ data.timberTypeId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="classId-label" sx={{ textAlign: "left" }}><Trans>Timber Class</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="classId-value" sx={{ textAlign: "left" }}>{ data.classId ? (<TimberClassLink id={ data.classId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } data-testid="thicknessClassId-label" sx={{ textAlign: "left" }}><Trans>Thickness Class</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="thicknessClassId-value" sx={{ textAlign: "left" }}>{ data.thicknessClassId ? (<ThicknessClassLink id={ data.thicknessClassId }/>) : '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } data-testid="price-label" sx={{ textAlign: "left" }}><Trans>Price</Trans>:</Grid>
                    <Grid size={ {xs: 8} } data-testid="price-value" sx={{ textAlign: "left" }}>{fixedFormat(data.price) || '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default PriceDetail;
